/* BEATSEEK — ID result artwork with a reliable fallback tile. */
import React, { useEffect, useRef, useState } from 'react';

export const ResultArtwork = ({ src, seed = '' }) => {
  const [failed, setFailed] = useState(false);
  const imgRef = useRef(null);
  const usable = !!src && src.startsWith('http') && !failed;

  // Some CDNs fail before React attaches onError, so verify the decoded bitmap too.
  useEffect(() => {
    setFailed(false);
    const check = () => {
      const el = imgRef.current;
      if (el && el.complete && el.naturalWidth === 0) setFailed(true);
    };
    check();
    const t = setTimeout(check, 1800);
    return () => clearTimeout(t);
  }, [src]);

  if (usable) {
    return (
      <img
        ref={imgRef}
        src={src}
        alt=""
        className="track-artwork"
        data-testid="id-result-artwork"
        onError={() => setFailed(true)}
        style={{ width: 72, height: 72, flex: '0 0 auto', borderRadius: 10, objectFit: 'cover', border: '1px solid rgba(0,212,255,0.25)', backgroundColor: '#12121c', display: 'block' }}
      />
    );
  }

  return (
    <div
      className="track-artwork-placeholder"
      data-testid="id-result-artwork-fallback"
      title={seed ? `No artwork for ${seed}` : 'No artwork'}
      style={{
        width: 72, height: 72, flex: '0 0 auto', borderRadius: 10,
        border: '1px solid rgba(0,212,255,0.25)',
        background: 'linear-gradient(135deg, #10243a, #1b0f2e)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >
      <img
        src="/beatseek-b-trans-1024.png"
        alt="BEATSEEK"
        data-testid="id-result-artwork-b"
        style={{ width: 56, height: 56, objectFit: 'contain', filter: 'drop-shadow(0 0 6px rgba(0,229,255,0.45))' }}
      />
    </div>
  );
};

export default ResultArtwork;
